var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"row my-2"},[_c('dt',{staticClass:"col-4"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.value.length > 0)?_c('dd',{staticClass:"col-8",domProps:{"innerHTML":_vm._s(_vm.value)}}):_c('dd',{staticClass:"col-8"},[_vm._v("N/A")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ea05e4c","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Homepage/components/CustomerPolicyRow.vue
// module id = null
// module chunks = 